module.exports = __webpack_public_path__ + "static/media/sd1.5d9e3a83.png";